import { c as _c } from "react/compiler-runtime";
import { AccommodationCard, AccommodationCardSkeleton } from "@website/accommodation-ui/accommodation-card";
import { HotelCitiesMainContentPropertiesType } from "@website/accommodation-ui/hotel-cities-main-content";
import { ListingContainerPropertiesType } from "@website/accommodation-ui/listing-container";
import { useFetcher, useFetchers } from "@website/fetcher/use-fetcher";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { Button } from "@website/ui/button";
import { useSnackbar } from "@website/ui/snackbar";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isInvalidCheckin, today, tomorrow } from "@website/utils/date-format";
import { ExperimentSDK } from "@website/utils/experiments/client";
import { isFilled } from "@website/utils/is-filled";
import { MapFilterProperties, useCityFilterState, useFilters } from "@website/widget/filter";
import { HeaderPropertiesType } from "@website/widget/header";
import { TelesalesAppName } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import last from "lodash-es/last";
import omit from "lodash-es/omit";
import orderBy from "lodash-es/orderBy";
import pick from "lodash-es/pick";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import uniq from "lodash-es/uniq";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useVillagesFilter } from "./filter.hook";
import { VILLA_LIST_PAGE_SIZE, fetchHotelRateData, fetchHotelReviewData, fetchInstalmentWallet, fetchVillagesData, transformHotelSchema, transformVillaListingSchema } from "./index.server";
import { handleEventMapSearchClicked, handleVillaAccommodationCardTrackingEvents, handleVillaCityPageVisited } from "./index.tracking";
import { CityPagePropertiesType, HotelCityContentItemType, VillaListingCardType, VillaLocationResponseType, reasonsSchema } from "./index.types";
import { useVillaSearch } from "./search.hook";
export const getBannersByType = (data, type: string) => data?.find?.(item => item?.type === type)?.data?.sort?.((a, b) => a?.order - b?.order) || null || [];
export const useCityPage = properties => {
  const $ = _c(247);
  const {
    locationData,
    villagesData,
    hasError,
    smallBanners,
    staticBanners
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [1];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [pages, setPages] = useState(t0);
  const router = useRouter();
  const [updatedModal, setUpdatedModal] = useState(false);
  const timerReference = useRef(null);
  const t1 = properties?.seoData?.pageTitle;
  let t2;
  if ($[1] !== locationData || $[2] !== t1) {
    t2 = {
      locationData,
      seoPageTitle: t1
    };
    $[1] = locationData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const searchProperties = useVillaSearch(t2);
  const {
    onOpenFilters
  } = useCityFilterState();
  const {
    isLoggedIn
  } = useLoginStatus();
  const selectedHotelId = router.query?.selectedHotelId;
  const {
    enqueue,
    dequeue
  } = useSnackbar();
  const isCompleteInfoDismissed = useRef(false);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["instalmentWallet"];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoggedIn) {
    t4 = {
      enabled: isLoggedIn,
      retry: false,
      queryKey: t3,
      queryFn: _temp
    };
    $[5] = isLoggedIn;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: instalmentWallet,
    isLoading: isInstallmentWalletLoading,
    isFetching: isInstallmentWalletFetching
  } = useFetcher(t4);
  let t5;
  if ($[7] !== pages || $[8] !== router.query) {
    let t6;
    if ($[10] !== router.query) {
      t6 = page => ({
        queryKey: ["villagesData", omit(router.query, ["modal", "selectedHotelId", "popover", "item", "filters_visible"]), page],
        queryFn: () => fetchVillagesData({
          ...router.query,
          page
        })
      });
      $[10] = router.query;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = pages.map(t6);
    $[7] = pages;
    $[8] = router.query;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = {
      queries: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const freshVillagesData = useFetchers(t6);
  let t7;
  if ($[14] !== freshVillagesData) {
    t7 = () => Promise.any(freshVillagesData.map(_temp2)).finally(() => setUpdatedModal(false));
    $[14] = freshVillagesData;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const updateResultSearchHandler = t7;
  let t8;
  if ($[16] !== router) {
    t8 = value => router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        order_by: value
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[16] = router;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const onSortChange = t8;
  let t10;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      timerReference.current = setTimeout(() => setUpdatedModal(true), 900000);
      return () => {
        timerReference.current && clearTimeout(timerReference.current);
      };
    };
    t10 = [];
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== router) {
    t11 = () => {
      if (!router.isReady) {
        return;
      }
      const {
        date_from,
        date_to
      } = router.query;
      const shouldRedirect = isInvalidCheckin(date_from, date_to);
      if (shouldRedirect) {
        router.replace({
          pathname: "/[locationType]/[cityTitle]",
          query: {
            locationType: router.query.locationType,
            cityTitle: router.query.cityTitle
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
      }
    };
    $[20] = router;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== router.isReady || $[23] !== router.query) {
    t12 = [router.isReady, router.query];
    $[22] = router.isReady;
    $[23] = router.query;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  useEffect(t11, t12);
  let t13;
  if ($[25] !== freshVillagesData) {
    t13 = !freshVillagesData?.length || freshVillagesData?.some(_temp3);
    $[25] = freshVillagesData;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const loading = t13;
  const villageResponses = freshVillagesData?.flatMap(_temp4) || [];
  let t14;
  if ($[27] !== router.query) {
    t14 = isEmpty(omit(router.query, ["locationType", "cityTitle"]));
    $[27] = router.query;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const hasOnlyLocationQuery = t14;
  let t15;
  if ($[29] !== hasOnlyLocationQuery) {
    t15 = hasOnlyLocationQuery || ExperimentSDK.isOn("new-villa-plp");
    $[29] = hasOnlyLocationQuery;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const isNewPlP = t15;
  const activeVillageResponses = hasOnlyLocationQuery && villageResponses.length === 0 ? villagesData ? [villagesData] : [] : villageResponses;
  const filteredVillages = activeVillageResponses.flatMap(_temp5);
  let t16;
  if ($[31] !== router.query) {
    t16 = response => ((response?.data || []) as Array<VillaLocationResponseType>).map(item => ({
      ...transformHotelSchema(item, router.query),
      count: toNumber(response.count || 0),
      total: toNumber(response.total || 0),
      page: toNumber(response.current_page || 1)
    }));
    $[31] = router.query;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const hotelCitiesMainContentList = activeVillageResponses.flatMap(t16);
  let t17;
  if ($[33] !== router.query.date_from || $[34] !== router.query.date_to || $[35] !== router.query.room_capacity) {
    t17 = (item_0, index) => transformVillaListingSchema(item_0, index, {
      ...(router.query?.date_from ? {
        date_from: toString(router.query.date_from)
      } : {}),
      ...(router.query?.date_to ? {
        date_to: toString(router.query.date_to)
      } : {}),
      ...(toNumber(router.query?.room_capacity) > 0 ? {
        room_capacity: toNumber(router.query.room_capacity)
      } : {})
    });
    $[33] = router.query.date_from;
    $[34] = router.query.date_to;
    $[35] = router.query.room_capacity;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const transformedVillages = filteredVillages.map(t17);
  const totalVillagesCount = last(activeVillageResponses)?.total || 0;
  const citiesFilterProperties = useVillagesFilter(totalVillagesCount, freshVillagesData?.[0]?.isFetched, locationData?.title, isNewPlP);
  let t18;
  if ($[37] !== citiesFilterProperties.filtersSchema) {
    t18 = {
      schema: citiesFilterProperties.filtersSchema
    };
    $[37] = citiesFilterProperties.filtersSchema;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const {
    selectedFiltersCount
  } = useFilters(t18);
  let t19;
  if ($[39] !== locationData) {
    t19 = locationData ? {
      id: locationData.id,
      title: locationData.title
    } : undefined;
    $[39] = locationData;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  const trackingLocation = t19;
  const hasSelectedFilters = selectedFiltersCount !== 0;
  let t20;
  if ($[41] !== hasSelectedFilters || $[42] !== locationData?.title || $[43] !== router.query.locationType) {
    t20 = hasSelectedFilters ? <>متاسفانه در حال حاضر هتل و اقامتگاهی متناسب با فیلتر های انتخابی شما در این بازه تاریخی وجود ندارد .</> : router.query.locationType === "category" ? <>متاسفانه در حال حاضر اقامتگاهی متناسب با دسته‌بندی انتخابی شما یافت نشد.</> : <>متاسفانه هتل و اقامتگاه فعالی در این بازه تاریخی در شهر{" "}<span className="text-on-surface-high-emphasis font-medium">"{locationData?.title}"</span>{" "}یافت نشد. لطفا شهرهای دیگر را جستجو کنید.</>;
    $[41] = hasSelectedFilters;
    $[42] = locationData?.title;
    $[43] = router.query.locationType;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const listingEmptyStateCaption = t20;
  let t21;
  if ($[45] !== citiesFilterProperties || $[46] !== hasSelectedFilters || $[47] !== searchProperties) {
    t21 = () => {
      if (hasSelectedFilters) {
        citiesFilterProperties.clearAllFilters();
        return;
      }
      searchProperties.setIsSearchPanelOpen(true);
    };
    $[45] = citiesFilterProperties;
    $[46] = hasSelectedFilters;
    $[47] = searchProperties;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  const handleListingEmptyStateAction = t21;
  const filteredPages = orderBy(uniq(activeVillageResponses.map(_temp6).filter(Boolean)));
  const [cityPageVisitFirstVilla] = transformedVillages;
  const cityPageVisitCity = trackingLocation?.title ?? cityPageVisitFirstVilla?.cityTitle ?? "";
  const cityPageVisitCityId = trackingLocation?.id ?? cityPageVisitFirstVilla?.cityId ?? 0;
  const cityPageVisitAvailableHotelIds = filteredVillages.filter(_temp7).map(_temp8).filter(Boolean).join(",");
  const cityPageVisitPage = last(filteredPages) || 0;
  let t22;
  if ($[49] !== router.query.locationType) {
    t22 = toString(router.query.locationType);
    $[49] = router.query.locationType;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  const cityPageVisitPageType = t22;
  let t23;
  if ($[51] !== router.query.date_from) {
    t23 = toString(router.query.date_from);
    $[51] = router.query.date_from;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  const cityPageVisitDateFrom = t23;
  let t24;
  if ($[53] !== router.query.date_to) {
    t24 = toString(router.query.date_to);
    $[53] = router.query.date_to;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  const cityPageVisitDateTo = t24;
  let t25;
  if ($[55] !== cityPageVisitAvailableHotelIds || $[56] !== cityPageVisitCity || $[57] !== cityPageVisitCityId || $[58] !== cityPageVisitDateFrom || $[59] !== cityPageVisitDateTo || $[60] !== cityPageVisitPage || $[61] !== cityPageVisitPageType) {
    t25 = [cityPageVisitCity, cityPageVisitCityId, cityPageVisitDateFrom, cityPageVisitDateTo, cityPageVisitAvailableHotelIds, cityPageVisitPage, cityPageVisitPageType];
    $[55] = cityPageVisitAvailableHotelIds;
    $[56] = cityPageVisitCity;
    $[57] = cityPageVisitCityId;
    $[58] = cityPageVisitDateFrom;
    $[59] = cityPageVisitDateTo;
    $[60] = cityPageVisitPage;
    $[61] = cityPageVisitPageType;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  const cityPageVisitTrackingKey = t25.join("|");
  const lastCityPageVisitTrackingKey = useRef(null);
  let t26;
  let t27;
  if ($[63] !== cityPageVisitAvailableHotelIds || $[64] !== cityPageVisitCity || $[65] !== cityPageVisitCityId || $[66] !== cityPageVisitDateFrom || $[67] !== cityPageVisitDateTo || $[68] !== cityPageVisitPage || $[69] !== cityPageVisitPageType || $[70] !== cityPageVisitTrackingKey || $[71] !== isNewPlP || $[72] !== loading) {
    t26 = () => {
      if (!isNewPlP || loading || !cityPageVisitCityId || lastCityPageVisitTrackingKey.current === cityPageVisitTrackingKey) {
        return;
      }
      lastCityPageVisitTrackingKey.current = cityPageVisitTrackingKey;
      handleVillaCityPageVisited({
        city: cityPageVisitCity,
        city_id: cityPageVisitCityId,
        date_from: new Date(cityPageVisitDateFrom),
        date_to: new Date(cityPageVisitDateTo),
        available_hotels_id: cityPageVisitAvailableHotelIds.split(",").filter(Boolean).map(Number),
        page: cityPageVisitPage,
        last_minute_loaded: 0,
        count_of_last_minute_cards: 0,
        blue_box_loaded: 0,
        count_of_blue_box_cards: 0,
        page_type: cityPageVisitPageType
      });
    };
    t27 = [cityPageVisitAvailableHotelIds, cityPageVisitCity, cityPageVisitCityId, cityPageVisitDateFrom, cityPageVisitDateTo, cityPageVisitPage, cityPageVisitPageType, cityPageVisitTrackingKey, isNewPlP, loading];
    $[63] = cityPageVisitAvailableHotelIds;
    $[64] = cityPageVisitCity;
    $[65] = cityPageVisitCityId;
    $[66] = cityPageVisitDateFrom;
    $[67] = cityPageVisitDateTo;
    $[68] = cityPageVisitPage;
    $[69] = cityPageVisitPageType;
    $[70] = cityPageVisitTrackingKey;
    $[71] = isNewPlP;
    $[72] = loading;
    $[73] = t26;
    $[74] = t27;
  } else {
    t26 = $[73];
    t27 = $[74];
  }
  useEffect(t26, t27);
  let t28;
  if ($[75] !== locationData?.location) {
    t28 = locationData?.location || {};
    $[75] = locationData?.location;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  const {
    latitude,
    longitude
  } = t28;
  const coordinate = latitude && longitude ? `${latitude},${longitude},11,33` : null;
  let t29;
  if ($[77] !== coordinate || $[78] !== locationData?.id || $[79] !== locationData?.title || $[80] !== router) {
    const goToMapFilter = () => {
      handleEventMapSearchClicked({
        city: locationData?.title,
        city_id: locationData?.id,
        date_from: toString(router.query?.date_from),
        date_to: toString(router.query?.date_to)
      });
      return router.push({
        pathname: "/map",
        query: {
          ...(coordinate ? {
            coordinate
          } : {}),
          ...omit(router.query, ["locationType", "cityTitle", "viewport_change_type"])
        }
      });
    };
    t29 = {
      label: "\u0645\u0634\u0627\u0647\u062F\u0647 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647",
      onClick: goToMapFilter
    };
    $[77] = coordinate;
    $[78] = locationData?.id;
    $[79] = locationData?.title;
    $[80] = router;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  const mapFilterProperties = t29;
  const t30 = Boolean(selectedHotelId);
  let t31;
  if ($[82] !== selectedHotelId) {
    t31 = ["hotelRateData", selectedHotelId];
    $[82] = selectedHotelId;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== t30 || $[85] !== t31) {
    t32 = {
      refetchOnMount: true,
      enabled: t30,
      queryKey: t31,
      queryFn: _temp9
    };
    $[84] = t30;
    $[85] = t31;
    $[86] = t32;
  } else {
    t32 = $[86];
  }
  const {
    data: hotelRateData
  } = useFetcher(t32);
  const t33 = Boolean(selectedHotelId);
  let t34;
  if ($[87] !== selectedHotelId) {
    t34 = ["hotelReviewData", selectedHotelId];
    $[87] = selectedHotelId;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  let t35;
  if ($[89] !== t33 || $[90] !== t34) {
    t35 = {
      refetchOnMount: true,
      enabled: t33,
      queryKey: t34,
      queryFn: _temp10
    };
    $[89] = t33;
    $[90] = t34;
    $[91] = t35;
  } else {
    t35 = $[91];
  }
  const {
    data: hotelReviewData
  } = useFetcher(t35);
  let t36;
  if ($[92] !== coordinate || $[93] !== router) {
    t36 = () => router?.push({
      pathname: "/map",
      query: {
        ...(coordinate ? {
          coordinate
        } : {}),
        ...omit(router?.query, ["cityTitle", "locationType", "extra_capacity", "modal", "coordinate", "viewport_change_type"])
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[92] = coordinate;
    $[93] = router;
    $[94] = t36;
  } else {
    t36 = $[94];
  }
  const onMapClick = t36;
  let t37;
  if ($[95] !== dequeue || $[96] !== enqueue || $[97] !== router.query || $[98] !== searchProperties.setIsSearchPanelOpen) {
    t37 = () => {
      if (["date_from", "date_to"].every(key => !isFilled(router.query[key]))) {
        if (isCompleteInfoDismissed.current) {
          return;
        }
        const buttonProperties = {
          onClick: () => {
            searchProperties.setIsSearchPanelOpen.bind(null, true)();
            setTimeout(() => {
              dequeue(snackBarId);
            }, 100);
          },
          color: "secondary" as const,
          variant: "text" as const
        };
        const snackBarId = enqueue("\u0628\u0631\u0627\u06CC \u0645\u0634\u0627\u0647\u062F\u0647 \u0642\u06CC\u0645\u062A \u062F\u0642\u06CC\u0642 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u066C \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.", "default", "one-line", <Button {...buttonProperties}>تکمیل اطلاعات</Button>);
        isCompleteInfoDismissed.current = true;
      }
    };
    $[95] = dequeue;
    $[96] = enqueue;
    $[97] = router.query;
    $[98] = searchProperties.setIsSearchPanelOpen;
    $[99] = t37;
  } else {
    t37 = $[99];
  }
  let t38;
  if ($[100] !== dequeue || $[101] !== enqueue || $[102] !== router || $[103] !== searchProperties.setIsSearchPanelOpen) {
    t38 = [router, searchProperties.setIsSearchPanelOpen, enqueue, dequeue];
    $[100] = dequeue;
    $[101] = enqueue;
    $[102] = router;
    $[103] = searchProperties.setIsSearchPanelOpen;
    $[104] = t38;
  } else {
    t38 = $[104];
  }
  useEffect(t37, t38);
  let t39;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = {
      title: "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"
    };
    $[105] = t39;
  } else {
    t39 = $[105];
  }
  const t40 = coordinate && mapFilterProperties;
  let t41;
  if ($[106] !== citiesFilterProperties || $[107] !== loading || $[108] !== t40) {
    t41 = {
      ...citiesFilterProperties,
      mapFilterProps: t40,
      loading
    };
    $[106] = citiesFilterProperties;
    $[107] = loading;
    $[108] = t40;
    $[109] = t41;
  } else {
    t41 = $[109];
  }
  let t42;
  if ($[110] !== updateResultSearchHandler || $[111] !== updatedModal) {
    t42 = {
      isOpen: updatedModal,
      onUpdateResult: updateResultSearchHandler
    };
    $[110] = updateResultSearchHandler;
    $[111] = updatedModal;
    $[112] = t42;
  } else {
    t42 = $[112];
  }
  const t43 = hasOnlyLocationQuery ? VILLA_LIST_PAGE_SIZE : 0;
  let t44;
  if ($[113] !== staticBanners) {
    t44 = getBannersByType(staticBanners, "static");
    $[113] = staticBanners;
    $[114] = t44;
  } else {
    t44 = $[114];
  }
  let t45;
  if ($[115] !== t44) {
    t45 = {
      slide: t44
    };
    $[115] = t44;
    $[116] = t45;
  } else {
    t45 = $[116];
  }
  const t46 = hasSelectedFilters ? "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627" : "\u062A\u063A\u06CC\u06CC\u0631 \u0645\u0642\u0635\u062F";
  const t47 = hasSelectedFilters ? "filters-not-found" : "not-found";
  let t48;
  if ($[117] !== handleListingEmptyStateAction || $[118] !== listingEmptyStateCaption || $[119] !== t46 || $[120] !== t47) {
    t48 = {
      actionTitle: t46,
      caption: listingEmptyStateCaption,
      onActionClick: handleListingEmptyStateAction,
      variant: t47
    };
    $[117] = handleListingEmptyStateAction;
    $[118] = listingEmptyStateCaption;
    $[119] = t46;
    $[120] = t47;
    $[121] = t48;
  } else {
    t48 = $[121];
  }
  let t49;
  if ($[122] !== router.query) {
    t49 = item_2 => <AccommodationCard {...item_2} handleTrackingEvents={trackingData => handleVillaAccommodationCardTrackingEvents({
      ...item_2,
      ...trackingData
    }, router.query)} />;
    $[122] = router.query;
    $[123] = t49;
  } else {
    t49 = $[123];
  }
  let t50;
  if ($[124] !== loading || $[125] !== t43 || $[126] !== t45 || $[127] !== t48 || $[128] !== t49 || $[129] !== transformedVillages) {
    t50 = {
      list: transformedVillages,
      isLoading: loading,
      animationStartIndex: t43,
      renderSkeleton: _temp11,
      getKey: _temp12,
      banners: t45,
      emptyState: t48,
      renderCard: t49
    };
    $[124] = loading;
    $[125] = t43;
    $[126] = t45;
    $[127] = t48;
    $[128] = t49;
    $[129] = transformedVillages;
    $[130] = t50;
  } else {
    t50 = $[130];
  }
  const t51 = t50 satisfies ListingContainerPropertiesType<VillaListingCardType>;
  const t52 = citiesFilterProperties.chipsFiltersSchema;
  const t53 = citiesFilterProperties.clearAllFilters;
  const t54 = citiesFilterProperties?.isFilterFetching;
  const t55 = locationData?.title;
  const t56 = router.query.locationType !== "category";
  const t57 = citiesFilterProperties?.hasNearby;
  const t58 = citiesFilterProperties.showStripLoadingSkeleton;
  const t59 = !hasOnlyLocationQuery;
  let t60;
  if ($[131] !== router.query.order_by) {
    t60 = toString(router.query.order_by);
    $[131] = router.query.order_by;
    $[132] = t60;
  } else {
    t60 = $[132];
  }
  let t61;
  if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = [{
      label: "\u0627\u0631\u0632\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "asc"
    }, {
      label: "\u06AF\u0631\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "desc"
    }];
    $[133] = t61;
  } else {
    t61 = $[133];
  }
  let t62;
  if ($[134] !== isNewPlP || $[135] !== onSortChange || $[136] !== t60) {
    t62 = {
      isNewPlP,
      onChange: onSortChange,
      initialValue: t60,
      list: t61
    };
    $[134] = isNewPlP;
    $[135] = onSortChange;
    $[136] = t60;
    $[137] = t62;
  } else {
    t62 = $[137];
  }
  let t63;
  if ($[138] !== citiesFilterProperties.chipsFiltersSchema || $[139] !== citiesFilterProperties.clearAllFilters || $[140] !== citiesFilterProperties.showStripLoadingSkeleton || $[141] !== isNewPlP || $[142] !== loading || $[143] !== onOpenFilters || $[144] !== selectedFiltersCount || $[145] !== t54 || $[146] !== t55 || $[147] !== t56 || $[148] !== t57 || $[149] !== t59 || $[150] !== t62 || $[151] !== totalVillagesCount) {
    t63 = {
      chipsFiltersSchema: t52,
      clearAllFilters: t53,
      loading,
      isFilterFetching: t54,
      setFilterOpen: onOpenFilters,
      city: t55,
      totalItem: totalVillagesCount,
      hasCityPrefix: t56,
      hasCityNearby: t57,
      selectedFiltersCount,
      showStripLoadingSkeleton: t58,
      shouldAnimateStripItems: t59,
      isNewPlP,
      sortProperties: t62
    };
    $[138] = citiesFilterProperties.chipsFiltersSchema;
    $[139] = citiesFilterProperties.clearAllFilters;
    $[140] = citiesFilterProperties.showStripLoadingSkeleton;
    $[141] = isNewPlP;
    $[142] = loading;
    $[143] = onOpenFilters;
    $[144] = selectedFiltersCount;
    $[145] = t54;
    $[146] = t55;
    $[147] = t56;
    $[148] = t57;
    $[149] = t59;
    $[150] = t62;
    $[151] = totalVillagesCount;
    $[152] = t63;
  } else {
    t63 = $[152];
  }
  let t64;
  if ($[153] !== filteredPages || $[154] !== loading || $[155] !== totalVillagesCount) {
    t64 = {
      pages: filteredPages,
      setPages,
      loading,
      totalCount: totalVillagesCount,
      pageSize: VILLA_LIST_PAGE_SIZE
    };
    $[153] = filteredPages;
    $[154] = loading;
    $[155] = totalVillagesCount;
    $[156] = t64;
  } else {
    t64 = $[156];
  }
  const t65 = locationData?.title;
  const t66 = citiesFilterProperties.clearAllFilters;
  const t67 = citiesFilterProperties?.hasNearby;
  const t68 = Number(selectedHotelId);
  let t69;
  if ($[157] !== hotelCitiesMainContentList) {
    t69 = hotelCitiesMainContentList || [];
    $[157] = hotelCitiesMainContentList;
    $[158] = t69;
  } else {
    t69 = $[158];
  }
  let t70;
  if ($[159] !== hotelReviewData?.rateReviews) {
    t70 = hotelReviewData?.rateReviews?.map(_temp13)?.splice(0, 5);
    $[159] = hotelReviewData?.rateReviews;
    $[160] = t70;
  } else {
    t70 = $[160];
  }
  let t71;
  if ($[161] !== hotelRateData || $[162] !== t70) {
    t71 = {
      rate: hotelRateData,
      comments: t70
    };
    $[161] = hotelRateData;
    $[162] = t70;
    $[163] = t71;
  } else {
    t71 = $[163];
  }
  const t72 = t71 as unknown as HotelCitiesMainContentPropertiesType["reviewData"];
  let t73;
  if ($[164] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = [];
    $[164] = t73;
  } else {
    t73 = $[164];
  }
  const t74 = searchProperties.setIsSearchPanelOpen;
  let t75;
  if ($[165] !== staticBanners) {
    t75 = getBannersByType(staticBanners, "static");
    $[165] = staticBanners;
    $[166] = t75;
  } else {
    t75 = $[166];
  }
  const t76 = instalmentWallet?.isEligible;
  const t77 = instalmentWallet?.showDownPayment;
  const t78 = instalmentWallet?.markup;
  const t79 = isInstallmentWalletLoading || isInstallmentWalletFetching;
  let t80;
  if ($[167] !== t76 || $[168] !== t77 || $[169] !== t78 || $[170] !== t79) {
    t80 = {
      isEligible: t76,
      showDownPayment: t77,
      markup: t78,
      isLoading: t79
    };
    $[167] = t76;
    $[168] = t77;
    $[169] = t78;
    $[170] = t79;
    $[171] = t80;
  } else {
    t80 = $[171];
  }
  let t81;
  if ($[172] !== citiesFilterProperties.clearAllFilters || $[173] !== hasError || $[174] !== hasSelectedFilters || $[175] !== isNewPlP || $[176] !== loading || $[177] !== searchProperties.setIsSearchPanelOpen || $[178] !== t65 || $[179] !== t67 || $[180] !== t68 || $[181] !== t69 || $[182] !== t72 || $[183] !== t75 || $[184] !== t80 || $[185] !== totalVillagesCount || $[186] !== trackingLocation) {
    t81 = {
      size: "small" as const,
      cityTitle: t65,
      clearAllFilters: t66,
      hasError,
      hasFilters: hasSelectedFilters,
      hasCityNearby: t67,
      selectedHotelId: t68,
      hotelList: t69,
      reviewData: t72,
      hotelsSuggested: t73,
      loading,
      setIsSearchPanelOpen: t74,
      bannerSlideList: t75,
      totalItem: totalVillagesCount,
      snappPayData: t80,
      trackingLocation,
      isNewPlP
    };
    $[172] = citiesFilterProperties.clearAllFilters;
    $[173] = hasError;
    $[174] = hasSelectedFilters;
    $[175] = isNewPlP;
    $[176] = loading;
    $[177] = searchProperties.setIsSearchPanelOpen;
    $[178] = t65;
    $[179] = t67;
    $[180] = t68;
    $[181] = t69;
    $[182] = t72;
    $[183] = t75;
    $[184] = t80;
    $[185] = totalVillagesCount;
    $[186] = trackingLocation;
    $[187] = t81;
  } else {
    t81 = $[187];
  }
  let t82;
  if ($[188] === Symbol.for("react.memo_cache_sentinel")) {
    t82 = getOrigin();
    $[188] = t82;
  } else {
    t82 = $[188];
  }
  let t83;
  if ($[189] !== isNewPlP) {
    t83 = {
      title: "\u0648\u06CC\u0644\u0627 \u0648 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      href: `${t82}/villa`,
      ...(isNewPlP ? {
        className: "!text-xs !leading-4"
      } : {})
    };
    $[189] = isNewPlP;
    $[190] = t83;
  } else {
    t83 = $[190];
  }
  let t84;
  if ($[191] !== isNewPlP || $[192] !== locationData?.state?.slug || $[193] !== locationData?.state?.title || $[194] !== router.query) {
    t84 = locationData?.state?.slug ? [{
      title: `ویلاهای استان ${locationData?.state?.title}`,
      ...(isNewPlP ? {
        className: "!text-xs !leading-4"
      } : {}),
      href: {
        pathname: "/[locationType]/[cityTitle]",
        query: {
          ...pick(router.query, ["cityTitle", "locationType"]),
          locationType: "state",
          cityTitle: locationData?.state?.slug
        }
      }
    }] : [];
    $[191] = isNewPlP;
    $[192] = locationData?.state?.slug;
    $[193] = locationData?.state?.title;
    $[194] = router.query;
    $[195] = t84;
  } else {
    t84 = $[195];
  }
  const t85 = router.query.locationType === "category" ? locationData?.title : ` ویلاهای ${locationData?.title}`;
  let t86;
  if ($[196] !== isNewPlP) {
    t86 = isNewPlP ? {
      className: "!text-xs !leading-4"
    } : {};
    $[196] = isNewPlP;
    $[197] = t86;
  } else {
    t86 = $[197];
  }
  let t87;
  if ($[198] !== router.query) {
    t87 = pick(router.query, ["cityTitle", "locationType"]);
    $[198] = router.query;
    $[199] = t87;
  } else {
    t87 = $[199];
  }
  let t88;
  if ($[200] !== t87) {
    t88 = {
      pathname: "/[locationType]/[cityTitle]",
      query: t87
    };
    $[200] = t87;
    $[201] = t88;
  } else {
    t88 = $[201];
  }
  let t89;
  if ($[202] !== t85 || $[203] !== t86 || $[204] !== t88) {
    t89 = {
      title: t85,
      ...t86,
      href: t88
    };
    $[202] = t85;
    $[203] = t86;
    $[204] = t88;
    $[205] = t89;
  } else {
    t89 = $[205];
  }
  let t90;
  if ($[206] !== t83 || $[207] !== t84 || $[208] !== t89) {
    t90 = {
      color: "default" as const,
      variant: "default" as const,
      list: [t83, ...t84, t89]
    };
    $[206] = t83;
    $[207] = t84;
    $[208] = t89;
    $[209] = t90;
  } else {
    t90 = $[209];
  }
  let t91;
  if ($[210] !== router.query.date_from) {
    t91 = router?.query?.date_from || today();
    $[210] = router.query.date_from;
    $[211] = t91;
  } else {
    t91 = $[211];
  }
  let t92;
  if ($[212] !== t91) {
    t92 = toString(t91);
    $[212] = t91;
    $[213] = t92;
  } else {
    t92 = $[213];
  }
  let t93;
  if ($[214] !== router.query.date_to) {
    t93 = router?.query?.date_to || tomorrow();
    $[214] = router.query.date_to;
    $[215] = t93;
  } else {
    t93 = $[215];
  }
  let t94;
  if ($[216] !== t93) {
    t94 = toString(t93);
    $[216] = t93;
    $[217] = t94;
  } else {
    t94 = $[217];
  }
  const t95 = router?.query?.cityTitle;
  let t96;
  if ($[218] !== t95) {
    t96 = toString(t95);
    $[218] = t95;
    $[219] = t96;
  } else {
    t96 = $[219];
  }
  let t97;
  if ($[220] !== t92 || $[221] !== t94 || $[222] !== t96) {
    t97 = {
      app: "villa" as TelesalesAppName,
      checkin: t92,
      checkout: t94,
      city_from: "",
      city_to: t96,
      funnel: "telesales_box"
    };
    $[220] = t92;
    $[221] = t94;
    $[222] = t96;
    $[223] = t97;
  } else {
    t97 = $[223];
  }
  const t98 = !isNewPlP;
  const t99 = isNewPlP ? "scroll" as const : undefined;
  let t100;
  if ($[224] !== isNewPlP || $[225] !== t97 || $[226] !== t98 || $[227] !== t99) {
    t100 = {
      description: " \u0628\u0639\u062F \u0627\u0632 \u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A\u060C \u06A9\u0627\u0631\u0634\u0646\u0627\u0633\u0627\u0646 \u0645\u0627 \u062F\u0631 \u0627\u0633\u0631\u0639 \u0648\u0642\u062A \u0628\u0627 \u0634\u0645\u0627 \u062A\u0645\u0627\u0633 \u062E\u0648\u0627\u0647\u0646\u062F \u06AF\u0631\u0641\u062A \u0648 \u0634\u0645\u0627 \u0631\u0627 \u0628\u0631\u0627\u06CC \u0631\u0632\u0631\u0648 \u0648\u06CC\u0644\u0627 \u0631\u0627\u0647\u0646\u0645\u0627\u06CC\u06CC \u062E\u0648\u0627\u0647\u0646\u062F \u06A9\u0631\u062F.",
      reasons: reasonsSchema,
      requestData: t97,
      storageKey: "villa_submit-tele-sale-reserve",
      className: "!left-6 !right-auto",
      showAnimatedMobileButton: t98,
      mobileButtonAnimation: t99,
      isNewPlP
    };
    $[224] = isNewPlP;
    $[225] = t97;
    $[226] = t98;
    $[227] = t99;
    $[228] = t100;
  } else {
    t100 = $[228];
  }
  let t101;
  if ($[229] !== smallBanners) {
    t101 = getBannersByType(smallBanners, "small");
    $[229] = smallBanners;
    $[230] = t101;
  } else {
    t101 = $[230];
  }
  let t102;
  if ($[231] !== t101) {
    t102 = {
      bannerSlideList: t101
    };
    $[231] = t101;
    $[232] = t102;
  } else {
    t102 = $[232];
  }
  const t103 = Boolean(coordinate);
  let t104;
  if ($[233] !== isNewPlP || $[234] !== onMapClick || $[235] !== searchProperties || $[236] !== t100 || $[237] !== t102 || $[238] !== t103 || $[239] !== t41 || $[240] !== t42 || $[241] !== t51 || $[242] !== t63 || $[243] !== t64 || $[244] !== t81 || $[245] !== t90) {
    t104 = {
      headerProps: t39 as HeaderPropertiesType,
      searchProperties,
      citiesFilterProperties: t41,
      modalProps: t42,
      listingContainerProps: t51,
      hotelListHeaderProps: t63,
      hotelPaginationProps: t64,
      hotelCitiesMainContentProps: t81,
      hotelBreadcrumbsProperties: t90,
      telesaleProperties: t100,
      bannersProperties: t102,
      onMapClick,
      hasMap: t103,
      isNewPlP
    };
    $[233] = isNewPlP;
    $[234] = onMapClick;
    $[235] = searchProperties;
    $[236] = t100;
    $[237] = t102;
    $[238] = t103;
    $[239] = t41;
    $[240] = t42;
    $[241] = t51;
    $[242] = t63;
    $[243] = t64;
    $[244] = t81;
    $[245] = t90;
    $[246] = t104;
  } else {
    t104 = $[246];
  }
  return t104;
};
function _temp() {
  return fetchInstalmentWallet();
}
function _temp2(t0) {
  const {
    refetch
  } = t0;
  return refetch();
}
function _temp3(t0) {
  const {
    isFetching,
    status
  } = t0;
  return isFetching || status === "pending";
}
function _temp4(t0) {
  const {
    data
  } = t0;
  return data ? [data] : [];
}
function _temp5(t0) {
  const {
    data: data_0
  } = t0;
  return (data_0 || []) as Array<VillaLocationResponseType>;
}
function _temp6(t0) {
  const {
    current_page
  } = t0;
  return current_page;
}
function _temp7(t0) {
  const {
    room_data
  } = t0;
  return room_data?.is_active;
}
function _temp8(t0) {
  const {
    room_data: room_data_0
  } = t0;
  return room_data_0.id;
}
function _temp9(t0) {
  const {
    queryKey
  } = t0;
  return fetchHotelRateData(queryKey[1]);
}
function _temp10(t0) {
  const {
    queryKey: queryKey_0
  } = t0;
  return fetchHotelReviewData(queryKey_0[1], 1, "villa", {} as Record<string, string>);
}
function _temp11() {
  return <AccommodationCardSkeleton />;
}
function _temp12(item_1) {
  return item_1.id;
}
function _temp13(comment) {
  return comment;
}